<template>
  <Section
    :id="id"
    :header="t('common.additionalParam', { param: t('shipments.services', 2) })"
    class="accessorial-section"
    data-class="flex flex-gap-1 flex-column"
  >
    <div class="accessorial-section-accessorials flex flex-gap-1 flex-wrap">
      <AccessorialInlineEdit
        v-for="accessorial in accessorials"
        :key="accessorial.id"
        :model-value="accessorial"
        :editable="false"
      />
    </div>
  </Section>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { AccessorialCode } from '@rygen/rygen-ui/model';

import AccessorialInlineEdit from '@/components/accessorial/AccessorialInlineEdit.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  accessorials: {
    type: Array as PropType<AccessorialCode[]>,
    default: () => [],
  },
});
const { id, accessorials } = toRefs(props);

const { t } = useI18n();
</script>
